module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "jbmzlsq"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showSuccess),
      expression: "!showSuccess"
    }],
    staticClass: "massage-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.clientMobile),
      expression: "clientMobile",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "clientMobile",
    attrs: {
      "type": "number",
      "placeholder": "请输入手机号码"
    },
    domProps: {
      "value": (_vm.clientMobile)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.clientMobile = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "verify"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.code),
      expression: "code",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "code",
    attrs: {
      "type": "text",
      "placeholder": "请输入验证码"
    },
    domProps: {
      "value": (_vm.code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.code = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "verifyButton",
    on: {
      "click": _vm.sendCode
    }
  }, [_vm._v(_vm._s(_vm.verifyMsg))])]), _vm._v(" "), _c('img', {
    staticClass: "button",
    attrs: {
      "src": require("./button.png"),
      "alt": ""
    },
    on: {
      "click": _vm.submit
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showSuccess),
      expression: "showSuccess"
    }],
    staticClass: "successHtml"
  }, [_c('img', {
    staticClass: "button",
    attrs: {
      "src": require("./successHtml.png"),
      "alt": ""
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-508a1ec4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/jbmzlsq/index.vue
// module id = 888
// module chunks = 2